import Mutations from '../../odata/mutations';

export default { ...new Mutations('moduleTask'), ...new Mutations('moduleTasks') };
